type CreateTaskIdOptions = {
  taskId: string;
  courseId: string;
};

export const createTaskId = ({ taskId, courseId }: CreateTaskIdOptions) =>
  courseId ? [courseId, taskId].join("-") : taskId;
